import React, { useEffect } from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton, HIDDEN_FILTER_CHIP } from '@components'
import ReportTableCreateReportButton from 'Pages/ReportsAlerts/Reports/@components/CrudTable/CreateReport'
import { useManageStatusMultiple, useReportBackendApiPath, useReportTableData } from 'Pages/ReportsAlerts/Reports/@hooks'
import { Box, capitalize, Divider } from '@mui/material'
import { actionsColumn, airportsColumn, dateColumn, frequencyColumn, frequencyHoursColumn, numSearchColumn, reportNameColumn, sitesColumn, statusColumn } from './columns'
import { reportListData, reportListStatusFilter } from '../../@signals'
import ReportListTableCustomToolbarSelect from './MultiToolbar'
import ReportTableFooter from './Footer'
import ReportTableStatusToggle from './StatusToggle'
import { getExcel } from '@ui-seeker/utils'


export default function ReportCrudTable() {
	const { isLoadingReportList, getTableContentData } = useReportTableData()
	const { reportType, backendUrl } = useReportBackendApiPath()

	useEffect(() => {
		getTableContentData()
	}, [])

	useManageStatusMultiple()

	if (isLoadingReportList) return <AppResultsSkeleton rows={10} columns={7}/>

	return <AppCrudTable
		title={<AppCardTitle icon="file-lines" title={`Reports ${capitalize(reportType)} List`}>
			<Box component="span" sx={{ ml: 0.75 }}><ReportTableStatusToggle/></Box>
		</AppCardTitle>}
		titleProps={{ variant: 'h6', component: 'div' }}
		components={{ TableFooter: ReportTableFooter }}
		data={reportListData.value}
		columns={[
			...reportNameColumn(),
			numSearchColumn(),
			...sitesColumn(),
			frequencyHoursColumn(),
			frequencyColumn(),
			...airportsColumn(),
			...dateColumn(!!reportType),
			...statusColumn(),
			actionsColumn()]}
		options={{
			selectableRows: 'multiple',
			// the selection bar floats over the page, so the table header stays as it is
			selectToolbarPlacement: 'above',
			customToolbarSelect: (selectedData, setSelectedRows) => <ReportListTableCustomToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}
			/>,
			customToolbar: () => <>
				<Divider orientation="vertical" flexItem sx={{ my: 1, ml: 1, mr: 1.5 }}/>
				<ReportTableCreateReportButton/>
			</>,
			// the Off/On filter has its own selector next to the title, so it gets no chip
			setFilterChipProps: (_, columnName) => columnName === 'enabled' ? { className: HIDDEN_FILTER_CHIP } : {},
			onFilterChange: (changedColumn, filterList, _, dataIdx) => {
				if (changedColumn === 'enabled')
					reportListStatusFilter.value = filterList[dataIdx]
			},
			onDownload: () => getExcel(`${backendUrl}/list/excel`, {}),
		}}
	/>
}